import React from 'react';
import Image from 'next/image';
import { benefits } from './constants';
import { Benefit, BenefitsContainer, Text } from './styles';

export const BenefitsOverview = () => (
  <BenefitsContainer>
    {benefits.map(({ icon, text }) => (
      <Benefit key={text}>
        <Image src={icon} alt="" height={60} width={60} />
        <Text>{text}</Text>
      </Benefit>
    ))}
  </BenefitsContainer>
);

BenefitsOverview.displayName = 'BenefitsOverview';
